;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import clsx from 'clsx'
import type React from 'react'

export function Field({ className, ...props }: React.ComponentPropsWithoutRef<'div'> & { className?: string }) {
  return (
    <div
      {...props}
      className={clsx(
        className,
        '[&>[data-slot=label]+[data-slot=control]]:mt-2',
        '[&>[data-slot=label]+[data-slot=description]]:mt-1',
        '[&>[data-slot=description]+[data-slot=control]]:mt-3',
        '[&>[data-slot=control]+[data-slot=description]]:mt-3',
        '[&>[data-slot=control]+[data-slot=error]]:mt-2',
        '*:data-[slot=label]:font-medium',
      )}
    />
  )
}

export function Label({
  className,
  required,
  children,
  ...props
}: {
  className?: string
  required?: boolean
} & React.ComponentPropsWithoutRef<'label'>) {
  return (
    <label
      data-slot="label"
      {...props}
      className={clsx(
        className,
        'text-base/6 text-mist-950 select-none data-disabled:opacity-50 sm:text-sm/6 dark:text-white',
      )}
    >
      <span>{children}</span>
      {required ? <span className="ml-1 text-red-400">*</span> : null}
    </label>
  )
}

export function ErrorMessage({ className, ...props }: React.ComponentPropsWithoutRef<'p'> & { className?: string }) {
  return (
    <p
      data-slot="error"
      // Announced when it appears: field errors render on submit or blur, and without this a
      // screen-reader user gets no signal that their input was rejected.
      role="alert"
      {...props}
      className={clsx(
        className,
        'w-full text-left text-xs/5 font-medium text-red-600 data-disabled:opacity-50 sm:text-sm/5 dark:text-red-300',
      )}
    />
  )
}
